import { useMemo, type ReactNode } from 'react'
import { useDataSource } from '@/src/renderer/lib/dataSource'
import { TestDataActionsContextProvider, type TestDataActions } from '@/src/renderer/lib/testData'

// Nachgeladen: Themen und Planer sollen nicht im App-Bündel stecken, solange niemand Testdaten anlegt.
const load = () => import('./index')

/**
 * **Testdaten für die Einstellungen und das Hauptfenster** (#269) — füllt den Kontext aus
 * `lib/testData` mit dem Erzeuger dieses Features, über die `DataSource` der Umgebung.
 *
 * @example
 * <TestDataActionsProvider><PreferencesPage /></TestDataActionsProvider>
 */
export function TestDataActionsProvider({ children }: { children: ReactNode }) {
  const source = useDataSource()
  const actions = useMemo<TestDataActions>(() => ({
    count: async () => (await load()).countTestData(source),
    create: async () => (await load()).createTestData(source),
    remove: async () => (await load()).removeTestData(source),
  }), [source])
  return <TestDataActionsContextProvider actions={actions}>{children}</TestDataActionsContextProvider>
}
